export default "__VITE_ASSET__CDqr1bmh__"